import React, { useState } from 'react'

import { BaseView } from '@/components/base'
import { AppIcons } from '@/components/AppIcons'
import { ChoosePeriodModal } from '@/components/ChoosePeriodModal'
import { useTheme } from '@/hooks/useTheme'
import { RangeDate } from '@/domain/transactions'

interface DatePickerButtonProps {
  appliedRangeDate: RangeDate
  setAppliedRangeDate: (range: RangeDate) => void
}

export const DatePickerButton: React.FC<DatePickerButtonProps> = ({
  appliedRangeDate,
  setAppliedRangeDate,
}) => {
  const theme = useTheme()
  const [showDatePicker, setShowDatePicker] = useState(false)

  const handleDatePickerClick = () => {
    setShowDatePicker(true)
  }

  const handleCloseModal = () => {
    setShowDatePicker(false)
  }

  return (
    <>
      {/* Date Picker Button */}
      <BaseView
        center
        px={12}
        py={12}
        style={{
          backgroundColor: theme.colors.background.secondaryGray + '40',
          borderRadius: '12px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        onClick={handleDatePickerClick}
      >
        <AppIcons name="clock" size={24} color="label.default" />
      </BaseView>

      {/* Choose Period Modal */}
      <ChoosePeriodModal
        isOpen={showDatePicker}
        onClose={handleCloseModal}
        appliedRangeDate={appliedRangeDate}
        setAppliedRangeDate={setAppliedRangeDate}
      />
    </>
  )
}
